import React from 'react';
import styled from 'styled-components';

import { BucketSearchExecution } from './BucketSearch/BucketSearchExecution';
import { Stack } from '@mui/material';
import { NodeAIArgument } from '@components/Flow/Nodes';
import { StaticDocumentExecution } from './StaticDocument/StaticDocumentExecution';
import { HTTPRequestExecution } from './HTTPRequest/HTTPRequestExecution';
import { TelnyxAPISearchExecution } from './TelnyxAPISearch/TelnyxAPISearchExecution';
import { TelnyxPricingExecution } from './TelnyxPricing/TelnyxPricingExecution';

import {
  AIToolMetadata,
  BucketSearchMetadata,
  HTTPRequestMetadata,
  StaticDocumentMetadata,
  TelnyxAPISearchMetadata,
  TelnyxPricingCalculatorMetadata,
  ToolDrawerOpen,
  ToolExecution,
} from '../../tool.types';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 1rem;
`;

interface Props {
  openTool: ToolDrawerOpen;
  toolExecutionConfig: {
    toolMetadata: AIToolMetadata;
    setToolMetadata: React.Dispatch<React.SetStateAction<AIToolMetadata>>;
    toolArguments: NodeAIArgument[];
  };
}

export const AssistantToolExecution: React.FC<Props> = ({ openTool, toolExecutionConfig }) => {
  const { toolMetadata, setToolMetadata, toolArguments } = toolExecutionConfig;

  const toolArgumentOptions = {
    tool: {
      args: toolArguments.reduce((acc, item) => {
        acc[item.name] = 'string';
        return acc;
      }, {} as Record<string, string>),
    },
  };

  return (
    <Container>
      <Stack spacing={1.5}>
        {openTool.tool.execution === ToolExecution.BUCKET_SEARCH && (
          <BucketSearchExecution
            metadata={toolMetadata as BucketSearchMetadata}
            setToolMetadata={setToolMetadata as React.Dispatch<React.SetStateAction<BucketSearchMetadata>>}
            toolArgumentOptions={toolArgumentOptions}
          />
        )}
        {openTool.tool.execution === ToolExecution.STATIC_DOCUMENT && (
          <StaticDocumentExecution
            metadata={toolMetadata as StaticDocumentMetadata}
            setToolMetadata={setToolMetadata as React.Dispatch<React.SetStateAction<StaticDocumentMetadata>>}
            toolArgumentOptions={toolArgumentOptions}
          />
        )}
        {openTool.tool.execution === ToolExecution.HTTP_REQUEST && (
          <HTTPRequestExecution
            metadata={toolMetadata as HTTPRequestMetadata}
            setToolMetadata={setToolMetadata as React.Dispatch<React.SetStateAction<HTTPRequestMetadata>>}
            toolArgumentOptions={toolArgumentOptions}
          />
        )}
        {openTool.tool.execution === ToolExecution.TELNYX_API_SEARCH && (
          <TelnyxAPISearchExecution
            metadata={toolMetadata as TelnyxAPISearchMetadata}
            setToolMetadata={setToolMetadata as React.Dispatch<React.SetStateAction<TelnyxAPISearchMetadata>>}
            toolArgumentOptions={toolArgumentOptions}
          />
        )}
        {openTool.tool.execution === ToolExecution.TELNYX_PRICING_CALCULATOR && (
          <TelnyxPricingExecution
            metadata={toolMetadata as TelnyxPricingCalculatorMetadata}
            setToolMetadata={setToolMetadata as React.Dispatch<React.SetStateAction<TelnyxPricingCalculatorMetadata>>}
            toolArgumentOptions={toolArgumentOptions}
          />
        )}
      </Stack>
    </Container>
  );
};
